module.exports = __webpack_public_path__ + "media/images/dashboards/safety-2a3812dcb5a57678b1456d39b331d48c.png";